import {ActionTree, GetterTree, MutationTree} from 'vuex';
import ThemeArray from '@/components/Theme/ThemeArray';
import Theme from '@/components/Theme/Theme';
import {client} from '@/components/api';

const URL: string = '/theme';

interface State {
    items: ThemeArray;
    examThemes: ThemeArray | null;
}

const state: State = {
    items: new ThemeArray(),
    examThemes: null,
};

const getters: GetterTree<State, any> = {
    themes: (state) => state.items,
    examThemes: (state) => {
        if (state.examThemes) {
            return state.examThemes.idArray.sort();
        } else {
            return null;
        }
    }
};

const mutations: MutationTree<State> = {
    addTheme(state, item: Theme) {
        state.items.add(item);
    },
    fillThemes(state, items: Theme[]) {
        state.items.refresh(items);
    },
    setExamThemes(state, payload: Theme[]) {
        const array: ThemeArray = new ThemeArray(payload);
        const set: Set<Theme> = array.unique();

        state.examThemes = new ThemeArray(set);
    },
    clearExamThemes(state) {
        state.examThemes = null;
    },
};

const actions: ActionTree<State, any> = {
    getThemes({commit}) {
        client.get(URL).then((response) => {
            const payload: Theme[] = response && response.data;
            commit('fillThemes', payload);
        }, (error) => {
            throw Error(`getThemes error: ${error}`);
        });
    },
};

export const themes = {
    state,
    getters,
    mutations,
    actions,
};

